import { FC, useEffect, useState } from 'react';
import { useApolloClient } from '@apollo/client';
import {
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  Flex,
  Heading,
} from '@chakra-ui/react';

import { EventType } from '../../graphql/generated';
import { clearCachedEvents } from '../file-activity-list/cache';
import { FileActivityListFilters } from '../file-activity-list/filters/filters';
import { MemoizedFileActivityList } from '../file-activity-list/list/list';

export type ActivityFeedProps = {
  cedant: string;
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
};

export const FileActivityPanel: FC<ActivityFeedProps> = ({
  isOpen,
  onClose,
  cedant,
}) => {
  const { cache } = useApolloClient();
  const [eventType, setEventType] = useState<EventType | undefined>();

  useEffect(() => {
    if (isOpen) {
      clearCachedEvents(cache, cedant);
      setEventType(undefined);
    }
  }, [cache, cedant, isOpen]);

  const handleFilterByEventType = (type: EventType) => {
    clearCachedEvents(cache, cedant);
    setEventType(type);
  };

  return (
    <Drawer size="md" placement="right" isOpen={isOpen} onClose={onClose}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton zIndex={1} data-testid="close-panel-btn" />
        <DrawerHeader>
          <Heading>Activity</Heading>
        </DrawerHeader>
        <DrawerBody as={Flex} flexDirection="column" gridGap="6">
          <Flex justifyContent="flex-end">
            <FileActivityListFilters
              width="58"
              onChange={handleFilterByEventType}
            />
          </Flex>
          <MemoizedFileActivityList
            cedant={cedant}
            onClose={onClose}
            eventType={eventType}
          />
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
